import { HttpClient } from '@angular/common/http';
import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';

/**
 * Generated class for the BookingsHoursPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bookings-hours',
  templateUrl: 'bookings-hours.html',
})
export class BookingsHoursPage {

  errors: {};
  loading: boolean;
  allShops: any[] = []; 
  viewTab:any="working_hours";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private http: HttpClient,
  ) {
  }

  ionViewDidLoad() {
    console.log("+++++++++");
  }
}



// WEBPACK FOOTER //
// ./src/pages/bookings-hours/bookings-hours.ts